import { withInstall } from '@/utils'
import ImportBtn from './src/index.vue'
export default withInstall(ImportBtn)
